<template>
  <div id="box">
    <HeaderView />
    <div class="banner">
      <img
        v-if="banners.length"
        :src="banners[currentIndex].img"
        alt="banner"
      />
      <div v-if="banners.length" class="banner-text">
        <span class="banner-title">
          {{ banners[currentIndex].title }}
        </span>
        <p class="banner-desc" v-html="banners[currentIndex].desc">
        </p>
      </div>
      <div class="progress-circle" v-if="banners.length > 1">
        <svg
          width="70"
          height="70"
          viewBox="0 0 80 80"
          style="margin: auto; display: block"
        >
          <circle
            cx="40"
            cy="40"
            r="30"
            fill="none"
            stroke="#fff"
            stroke-width="4"
            class="progress-bg"
          />
          <circle
            cx="40"
            cy="40"
            r="30"
            fill="none"
            stroke="#fff"
            stroke-width="6"
            stroke-linecap="round"
            class="progress-bar"
            :stroke-dasharray="circumference"
            :stroke-dashoffset="strokeDashoffset"
            transform="rotate(-90 40 40)"
          />
        </svg>
      </div>
      <div class="banner-btn">
        <img src="/imgs/home/images/shubiao_05.png" alt="" />
        <span class="btn">了解更多</span>
        <img src="/imgs/home/images/more_09.png" alt="" />
      </div>
    </div>

    <section class="section1">
      <img
        src="/imgs/home/images/s1-bg_02.png"
        class="section1-bg wow slideInLeft"
        alt=""
      />
      <div class="section-container wow fadeInRight">
        <div class="section1-content">
          <div class="section1-header">
            <h2 class="section1-title">走进企业</h2>
            <div class="section1-divider"></div>
            <p class="section1-subtitle">ENTER THE ENTERPRISE</p>
          </div>

          <div class="section1-text">
            <div v-html="aboutContent"></div>
            <div class="section1-text-footer">
              <button class="section1-btn" @click="goCompany">
                探索更多
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  style="
                    margin-left: 8px;
                    vertical-align: middle;
                    display: inline-block;
                  "
                >
                  <circle
                    cx="9"
                    cy="9"
                    r="8"
                    fill="#fff"
                    stroke="#e0e0e0"
                    stroke-width="1"
                  />
                  <path
                    d="M7 6l4 3-4 3"
                    stroke="#000"
                    stroke-width="1"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div class="section1-stats">
            <div class="stat-item">
              <img src="/imgs/home/images/s1icon1_03.png" alt="" />
              <h3>{{ formattedGnjg }}</h3>
              <p>国内加工基地</p>
            </div>
            <div class="stat-item">
              <img src="/imgs/home/images/s1icon2_03.png" alt="" />
              <h3>{{ formattedMfqycq }}</h3>
              <p>毛纺企业长期首选供应商</p>
            </div>
            <div class="stat-item">
              <img src="/imgs/home/images/s1icon3_03.png" alt="" />
              <h3>{{ formattedGuoji }}</h3>
              <p>国际品牌纳入原料采购体系</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section2">
      <img src="/imgs/home/images/s2-bg_10.png" class="section2-bg" alt="" />
      <div class="section-container">
        <div class="section2-header wow fadeInDown">
          <h2 class="section2-title">产品介绍</h2>
          <div class="section2-divider"></div>
          <p class="section2-subtitle">PRODUCT INTRODUCTION</p>
        </div>
        <div class="section2-content wow fadeInUp">
          <div
            v-for="(product, index) in products"
            :key="product.id"
            class="product-item"
            :class="
              index === 0 ? 'wow rotateInDownLeft' : 'wow rotateInDownRight'
            "
          >
            <div
              class="product-image-wrapper"
              @click="goToProductDetail(product.id)"
            >
              <div class="product-image">
                <img :src="product.image.trim()" :alt="product.title" />
              </div>
              <img
                src="/imgs/home/images/dianji_11.png"
                alt="点击图标"
                class="click-icon"
              />
            </div>
            <h3 class="product-name">{{ product.title }}</h3>
            <div class="product-description">
              <p>{{ product.n_title }}</p>
              {{ product.brief }}
            </div>
            <div class="learn-more" @click="goToProductDetail(product.id)">
              了解更多>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section3">
      <div class="section-container section3-container">
        <div class="section2-header wow fadeInDown" style="margin-bottom: 0rem">
          <h2 class="section2-title">服务应用领域</h2>
          <div class="section2-divider"></div>
          <p class="section2-subtitle">FIELD OF APPLICATION</p>
          <p class="section-desc">
            我们以秘鲁羊驼毛为核心赛道，逐步构建从原料端到加工端的全链条竞争优势
          </p>
        </div>
        <div class="section3-content wow slideInUp animate__delay-2s">
          <div class="accordion">
            <div
              class="accordion-item"
              v-for="(item, index) in accordionItems"
              :key="index"
              :class="{ active: activeIndex === index }"
              @mouseenter="activeIndex = index"
            >
              <div class="accordion-image">
                <img
                  :src="
                    activeIndex === index
                      ? item.expandedImage
                      : item.collapsedImage
                  "
                  :alt="item.title"
                />
              </div>
              <div class="accordion-content">
                <h3 class="accordion-title">{{ item.title }}</h3>
                <p class="accordion-desc" v-if="activeIndex === index">
                  {{ item.description }}
                </p>
                <button class="section3-btn" v-if="activeIndex === index" @click="$router.push('/field')">
                  探索更多
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    style="
                      margin-left: 8px;
                      vertical-align: middle;
                      display: inline-block;
                    "
                  >
                    <circle
                      cx="9"
                      cy="9"
                      r="8"
                      fill="#b06723"
                      stroke="#b06723"
                      stroke-width="1"
                    />
                    <path
                      d="M7 6l4 3-4 3"
                      stroke="#fff"
                      stroke-width="1"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section4">
      <div class="section-container section4-container">
        <div class="section2-header wow fadeInDown">
          <h2 class="section2-title">关于羊驼</h2>
          <div class="section2-divider"></div>
          <p class="section2-subtitle">ABOUT ALPACA</p>
          <div class="about-tab">
            <div
              class="tab-item"
              v-for="(category, index) in categoryabout"
              :key="category.id"
              @click="AboutactiveIndex = index"
              :class="{ active: AboutactiveIndex === index }"
            >
              {{ category.name }}
            </div>
            <div class="tab-item" @click="goToWoolSpecifications">
              羊驼毛规格
            </div>
          </div>
        </div>
        <div class="section4-content wow fadeInUp">
          <div
            class="alpaca-item"
            v-for="(item, index) in alpacaItems"
            :key="item.id"
            :class="{ active: hoveredIndex === index }"
            @mouseenter="hoveredIndex = index"
            @mouseleave="hoveredIndex = -1"
          >
            <div class="alpaca-image-wrapper">
              <img :src="item.image" :alt="item.title" class="alpaca-image" />
              <div class="alpaca-info" v-if="hoveredIndex === index">
                <h3 class="alpaca-name">{{ item.title }}</h3>
                <p class="alpaca-english">{{ item.e_title }}</p>
                <p class="alpaca-description">{{ item.brief }}</p>
              </div>
            </div>
            <div class="alpaca-label-container">
              <div class="alpaca-label">{{ item.title }}</div>
              <div class="alpaca-label-english">{{ item.e_title }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section5">
      <div class="section-container section5-container">
        <div class="section2-header wow fadeInDown">
          <h2 class="section2-title">合作伙伴</h2>
          <div class="section2-divider"></div>
          <p class="section2-subtitle">PARTNERS</p>
          <p class="section-desc">
            {{ partnerDesc }}
          </p>
        </div>
        <div class="section5-content wow fadeInUp">
          <div class="logo-wall">
            <div
              class="logo-item"
              v-for="partner in partners"
              :key="partner.id"
            >
              <div class="logo-parallelogram">
                <img :src="partner.image" alt="合作伙伴logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <FooterView />
  </div>
</template>

<script>
import apiServe from "@/services/index.js";
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
import WOW from "wow.js";

export default {
  name: "HomeView",
  components: {
    HeaderView,
    FooterView,
  },
  data() {
    return {
      banners: [], // 初始化为空数组，后续从接口获取数据
      currentIndex: 0,
      timer: null,
      progressTimer: null,
      circumference: 2 * Math.PI * 30,
      strokeDashoffset: 0,
      progress: 0,
      activeIndex: 1, // 默认展开第二个项目
      accordionItems: [], // 初始化为空数组，后续从接口获取数据
      hoveredIndex: -1,
      AboutactiveIndex: 0, // 默认激活第一个tab
      categoryabout: [], // 存储从接口获取的分类数据
      alpacaItems: [], // 存储当前tab下的羊驼数据
      partners: [], // 存储合作伙伴数据
      products: [], // 存储产品数据
      partnerDesc: "", // 存储合作伙伴描述文案
      aboutContent: "", // 存储关于我们HTML内容
      gnjg: 2, // 国内加工基地数量
      mfqycq: 80, // 毛纺企业长期首选供应商比例
      guoji: 12, // 国际品牌纳入原料采购体系数量
      // 动画相关数据
      animatedGnjg: 0,
      animatedMfqycq: 0,
      animatedGuoji: 0,
      statsObserver: null,
      animationTimers: {},
      animationsStarted: false,
    };
  },
  created() {},
  mounted() {
    this.getIndexData();
    this.getAboutData();
    // 初始化 WOW.js 动画
    this.initWOW();
    // 初始化统计数字观察者
    this.initStatsObserver();
  },
  // 当 banners 数据更新时，根据数量决定是否启动轮播
  computed: {
    // 格式化国内加工基地数字
    formattedGnjg() {
      return Math.floor(this.animatedGnjg).toString();
    },
    // 格式化毛纺企业长期首选供应商数字
    formattedMfqycq() {
      // 检查是否包含百分比符号
      if (this.mfqycq.toString().includes('%')) {
        return Math.floor(this.animatedMfqycq) + '%';
      }
      return Math.floor(this.animatedMfqycq).toString();
    },
    // 格式化国际品牌纳入原料采购体系数字
    formattedGuoji() {
        // 检查是否包含加号
        if (this.guoji.toString().includes('+')) {
        return Math.floor(this.animatedGuoji) + '+';
      }
      return Math.floor(this.animatedGuoji).toString();
    }
  },
  watch: {
    banners(newBanners) {
      if (newBanners.length > 1) {
        this.startCarousel();
        this.startProgressAnimation();
      }
    },
    // 当tab切换时更新羊驼数据
    AboutactiveIndex(newIndex) {
      if (this.categoryabout[newIndex] && this.categoryabout[newIndex].list) {
        this.alpacaItems = this.categoryabout[newIndex].list;
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.progressTimer) {
      clearInterval(this.progressTimer);
    }
    // 清理统计数字动画计时器
    for (const timerId in this.animationTimers) {
      clearInterval(this.animationTimers[timerId]);
    }
    // 清理IntersectionObserver
    if (this.statsObserver) {
      this.statsObserver.disconnect();
    }
  },
  // Vue Router生命周期钩子，处理页面导航
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.resetAnimationState();
      vm.reloadData();
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.resetAnimationState();
    this.reloadData();
    next();
  },
  methods: {
    getIndexData() {
      apiServe.getIndexData().then((res) => {
        this.IndexData = res.data;
        // 将接口返回的 banner 数据映射到 banners 数组
        this.banners = res.data.banner.map((item) => ({
          img: item.image,
          title: item.title,
          desc: item.brief,
        }));
        // 将接口返回的 appfield 数据映射到 accordionItems
        this.accordionItems = res.data.appfield.map((item) => ({
          title: item.title,
          description: item.brief,
          collapsedImage: item.s_image.trim(), // 使用 s_image 作为未展开的竖图
          expandedImage: item.image.trim(), // 使用 n_image 作为展开的图片
        }));
        // 处理categoryabout数据
        this.categoryabout = res.data.categoryabout;
        // 初始化第一个tab的羊驼数据
        if (this.categoryabout.length > 0 && this.categoryabout[0].list) {
          this.alpacaItems = this.categoryabout[0].list;
        }
        // 处理合作伙伴数据
        this.partners = res.data.partner || [];
        // 处理产品数据
        this.products = res.data.product || [];
      });
    },
    // 获取关于我们数据
    getAboutData() {
      apiServe.getAboutData().then((res) => {
        // 保存关于我们HTML内容
        this.aboutContent = res.data.about;
        // 处理合作伙伴描述文案
        this.partnerDesc = res.data.homehz;
        // 保存统计数据
        this.gnjg = res.data.gnjg;
        this.mfqycq = res.data.mfqycq;
        this.guoji = res.data.guoji;
        
        // 数据加载完成后，检查统计模块是否已经可见，如果可见则立即启动动画
        const statsSection = document.querySelector('.section1-stats');
        if (statsSection) {
          const rect = statsSection.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
          if (isVisible && !this.animationsStarted) {
            this.startStatsAnimation();
          }
        }
      });
    },
    // 重置动画状态
    resetAnimationState() {
      // 重置动画值
      this.animatedGnjg = 0;
      this.animatedMfqycq = 0;
      this.animatedGuoji = 0;
      // 重置动画状态标志
      this.animationsStarted = false;
      // 清除所有动画计时器
      for (const timerId in this.animationTimers) {
        clearInterval(this.animationTimers[timerId]);
      }
      this.animationTimers = {};
      // 重新初始化观察者
      this.initStatsObserver();
    },
    // 重新加载数据
    reloadData() {
      this.getIndexData();
      this.getAboutData();
    },
    startCarousel() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.banners.length;
        this.resetProgress();
      }, 3000);
    },
    startProgressAnimation() {
      this.progressTimer = setInterval(() => {
        this.progress += 1;
        if (this.progress >= 100) {
          this.progress = 0;
        }
        this.strokeDashoffset =
          this.circumference - (this.progress / 100) * this.circumference;
        // 留出2%的缺口，让起点和终点错开一点
        // const gap = this.circumference * 0.02;
        // this.strokeDashoffset = this.circumference - (this.progress / 100) * (this.circumference - gap) + gap / 2;
      }, 30);
    },
    resetProgress() {
      this.progress = 0;
      this.strokeDashoffset = 0;
    },
    // 跳转到公司介绍页
    goCompany() {
      this.$router.push("/company");
    },
    // 跳转到产品介绍页并选中对应标签
    goToProductDetail(productId) {
      this.$router.push({ path: '/product', query: { productId } });
    },
    // 跳转到羊驼毛规格页面
    goToWoolSpecifications() {
      this.$router.push("/about#section2");
    },
    // 初始化 WOW.js 动画
    initWOW() {
      new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 200,
        mobile: true,
        live: true,
      }).init();
    },
    // 数字增长动画
    animateNumber(targetId, start, end, duration) {
      // 清除之前的计时器
      if (this.animationTimers[targetId]) {
        clearInterval(this.animationTimers[targetId]);
      }
      
      const range = end - start;
      const increment = range / (duration / 16); // 以16ms为间隔
      let current = start;
      
      this.animationTimers[targetId] = setInterval(() => {
        current += increment;
        
        if ((increment > 0 && current >= end) || (increment < 0 && current <= end)) {
          current = end;
          clearInterval(this.animationTimers[targetId]);
          delete this.animationTimers[targetId];
        }
        
        // 更新对应的动画值
        if (targetId === 'gnjg') {
          this.animatedGnjg = current;
        } else if (targetId === 'mfqycq') {
          this.animatedMfqycq = current;
        } else if (targetId === 'guoji') {
          this.animatedGuoji = current;
        }
      }, 16);
    },
    // 启动所有统计数字动画
    startStatsAnimation() {
      if (this.animationsStarted) return;
      this.animationsStarted = true;
      
      // 解析目标值，移除可能的百分比符号，并确保是有效数字
      const parseTarget = (value) => {
        const parsed = parseInt(value.toString().replace(/[^\d]/g, ''));
        return isNaN(parsed) ? 0 : parsed;
      };
      
      const gnjgTarget = parseTarget(this.gnjg);
      const mfqycqTarget = parseTarget(this.mfqycq);
      const guojiTarget = parseTarget(this.guoji);
      
      // 只有当目标值大于0时才启动动画
      if (gnjgTarget > 0) {
        this.animateNumber('gnjg', 0, gnjgTarget, 1500);
      }
      if (mfqycqTarget > 0) {
        this.animateNumber('mfqycq', 0, mfqycqTarget, 1500);
      }
      if (guojiTarget > 0) {
        this.animateNumber('guoji', 0, guojiTarget, 1500);
      }
    },
    // 初始化统计数字观察者
    initStatsObserver() {
      // 先清理已有的观察者
      if (this.statsObserver) {
        this.statsObserver.disconnect();
        this.statsObserver = null;
      }
      
      const statsSection = document.querySelector('.section1-stats');
      if (!statsSection) return;
      
      this.statsObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.startStatsAnimation();
            // 动画启动后停止观察
            this.statsObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.5 // 当元素50%可见时触发
      });
      
      this.statsObserver.observe(statsSection);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/animate.css";
</style>
<style src="../assets/home.css" scoped></style>